import React from 'react';
import { DeleteOutlined } from '@ant-design/icons';
import { List, Typography, Button } from 'antd';
import {
  number, func, shape, string, oneOfType, arrayOf, bool,
} from 'prop-types';
import FileIcon from 'components/file-icon';
import ErrorsAlert from 'components/errors-alert/ErrorsAlert';

const { Link, Text } = Typography;

const fileExtension = (file) => {
  if (file.extension) return file.extension.toLowerCase();

  const nameParts = file.name.split('.');
  return nameParts.length >= 2 ? nameParts.at(-1).toLowerCase() : null;
};

const TicketAttachmentListItem = ({
  file,
  hideItem,
  errorColor = '#CC0000',
  errors = [],
  clearErrors,
  isCurrentUserAuthor = true,
}) => {
  const extension = fileExtension(file);
  const sizeMb = file.size / 1024 / 1024 || 0;
  const formattedSize = `${sizeMb.toFixed(2)} Mb`;

  const titleContent = (
    <>
      {file.name}
      <Text type="secondary">
        {' | '}
        {[extension, formattedSize].filter(Boolean).join(' | ')}
      </Text>
    </>
  );

  const title = (() => {
    if (errors.length) return <Text type="danger">{titleContent}</Text>;
    if (file.url) return <Link href={file.url} target="_blank">{titleContent}</Link>;
    return <Text>{titleContent}</Text>;
  })();

  const description = errors.length
    ? <ErrorsAlert errors={errors} clearErrors={clearErrors} />
    : null;

  const deleteAction = isCurrentUserAuthor ? [
    <Button
      type="link"
      style={{ padding: 0 }}
      onClick={hideItem}
    >
      <DeleteOutlined style={{ color: errorColor }} />
    </Button>,
  ] : [];

  return (
    <List.Item actions={deleteAction}>
      <List.Item.Meta
        avatar={(
          <FileIcon
            format={extension}
            status={file.status === 'done' ? null : file.status}
            style={{
              fontSize: 30,
              color: file.status === 'error' ? errorColor : '#555',
            }}
          />
        )}
        title={title}
        description={description}
      />
    </List.Item>
  );
};

TicketAttachmentListItem.propTypes = {
  file: shape({
    url: string,
    name: string,
    uid: oneOfType([number, string]),
    status: string,
    size: number,
    extension: string,
    id: number,
  }).isRequired,
  hideItem: func.isRequired,
  clearErrors: func.isRequired,
  errorColor: string,
  errors: arrayOf(shape({})),
  isCurrentUserAuthor: bool,
};

export { TicketAttachmentListItem };
